export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_BASE_URL;

/**
 * Build an absolute, openable media URL from whatever the API returns.
 *
 * Handles all three shapes that show up on prod:
 *   1. Absolute URL (https://api.../media/...) → return as-is.
 *   2. Relative path → prepend MEDIA_BASE_URL.
 *   3. MEDIA_BASE_URL missing → derive from BASE_URL by stripping the
 *      trailing /api and appending /media.
 *
 * Returns "" for null / undefined so callers never render
 * "undefinedhttps://..." into src= attributes.
 */
export const resolveMediaUrl = (url?: string | null): string => {
  if (!url || typeof url !== "string") return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (MEDIA_BASE_URL) {
    const clean = MEDIA_BASE_URL.replace(/\/$/, "");
    return `${clean}${url.startsWith("/") ? url : `/${url}`}`;
  }
  if (BASE_URL) {
    const origin = BASE_URL.replace(/\/?api\/?$/, "").replace(/\/$/, "");
    return `${origin}/media${url.startsWith("/") ? url : `/${url}`}`;
  }
  return url;
};
